/* eslint-disable react/no-unescaped-entities */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Grid, TextField } from '@material-ui/core/';

const useStyles = makeStyles(() =>
  createStyles({
    myTextField: {
      backgroundColor: 'none',
      boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
      border: 'none',
      color: '#717171',
      fontWeight: 'bold',
      fontFamily: 'Open Sans',
    },
    text: {
      fontFamily: 'Open Sans',
      fontWeight: 'bold',
      color: '#717171',
    },
  }),
);

export default function TaxOwner() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Grid
      container
      spacing={1}
      style={{
        border: '2px solid #c5c5c5',
        borderRadius: 10,
        justifyContent: 'center',
        padding: 10,
      }}
    >
      <Grid
        container
        spacing={1}
        style={{
          justifyContent: 'space-between',
          padding: 1,
        }}
      >
        <h5 className="text-box-inform">
          {t('Product.creditCard.checkout.client.label1')}
        </h5>
        <p className="text-box-inform-2">COD.: PROD_CARDPP_002</p>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{
          justifyContent: 'space-between',
          padding: 1,
        }}
      >
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <p className="text-select-label ">
            {t('Product.creditCard.checkout.client.monthlyPayment')}
          </p>
          {/* <input className="myInput-tax" placeholder="R$ 00,00" /> */}
          <TextField
            classes={{ notchedOutline: classes.input }}
            className={classes.text}
            // fullWidth
            id="outlined-basic"
            label="R$ 00,00"
            variant="outlined"
            size="small"
            // inputRef={search}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <p className="text-select-label ">
            {t('Product.creditCard.checkout.client.passwordUnlock')}
          </p>
          <TextField
            classes={{ notchedOutline: classes.input }}
            className={classes.text}
            // fullWidth
            id="outlined-basic"
            label="R$ 00,00"
            variant="outlined"
            size="small"
            // inputRef={search}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <p className="text-select-label ">
            {t('Product.creditCard.checkout.client.withdraw')}
          </p>
          <TextField
            classes={{ notchedOutline: classes.input }}
            className={classes.text}
            // fullWidth
            id="outlined-basic"
            label="R$ 00,00"
            variant="outlined"
            size="small"
            // inputRef={search}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <p className="text-select-label ">
            {t('Product.creditCard.checkout.client.transfer')}
          </p>
          <TextField
            classes={{ notchedOutline: classes.input }}
            className={classes.text}
            // fullWidth
            id="outlined-basic"
            label="R$ 00,00"
            variant="outlined"
            size="small"
            // inputRef={search}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <p className="text-select-label ">
            {t('Product.creditCard.checkout.client.duplicateCard')}
          </p>
          <TextField
            classes={{ notchedOutline: classes.input }}
            className={classes.text}
            // fullWidth
            id="outlined-basic"
            label="R$ 00,00"
            variant="outlined"
            size="small"
            // inputRef={search}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text,
              },
            }}
          />
        </Grid>
      </Grid>
      {/* <div style={{
      display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
       alignItems: 'center', marginBottom: 40,
    }}
    > */}
      <Grid
        container
        spacing={1}
        style={{
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 1,
        }}
      >
        {/* <Grid item xs={12} sm={6} md={3} lg={3}>
          <p className="text-select-label ">
            {t('Product.creditCard.checkout.client.duplicateCard')}
          </p>
          <TextField
            classes={{ notchedOutline: classes.input }}
            className={classes.text}
            // fullWidth
            id="outlined-basic"
            label="R$ 00,00"
            variant="outlined"
            size="small"
            // inputRef={search}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text,
              },
            }}
          />
        </Grid> */}
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <p className="text-select-label ">
            {t('Product.creditCard.checkout.client.chargebackFee')}
          </p>
          <TextField
            classes={{ notchedOutline: classes.input }}
            className={classes.text}
            // fullWidth
            id="outlined-basic"
            label="R$ 00,00"
            variant="outlined"
            size="small"
            // inputRef={search}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <p className="text-select-label ">
            {t('Product.creditCard.checkout.client.chargebackTax')}
          </p>
          <TextField
            classes={{ notchedOutline: classes.input }}
            className={classes.text}
            // fullWidth
            id="outlined-basic"
            label="R$ 00,00"
            variant="outlined"
            size="small"
            // inputRef={search}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <p className="text-select-label ">
            {t('Product.creditCard.checkout.client.mktTax')}
          </p>
          <TextField
            classes={{ notchedOutline: classes.input }}
            className={classes.text}
            // fullWidth
            id="outlined-basic"
            label="R$ 00,00"
            variant="outlined"
            size="small"
            // inputRef={search}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <p className="text-select-label ">
            {t('Product.creditCard.checkout.client.iof')}
          </p>
          <TextField
            classes={{ notchedOutline: classes.input }}
            className={classes.text}
            // fullWidth
            id="outlined-basic"
            label="R$ 00,00"
            variant="outlined"
            size="small"
            // inputRef={search}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2} />
        {/* </div> */}
      </Grid>
    </Grid>
    //       <p className="text-select-label ">{t('Product.creditCard.checkout.client.mktTax')}</p>
    //       <input className="myInput-tax-owner" placeholder="R$ 00,00" />
    //     </div>
    //     <div style={{ marginLeft: 25 }}>
    //       <p className="text-select-label ">{t('Product.creditCard.checkout.client.iof')}</p>
    //       <input className="myInput-tax-owner" placeholder="R$ 00,00" />
    //     </div>
    //   </div>
    // </div>
  );
}
